import { Periodicity } from "@modules/completedSessions/completedSessionsType"
import { useServicesContext } from "@modules/core/services/services.context"
import { PublicProfileEntity } from "@modules/profile/publicProfile/entities/publicProfileEntity"
import { useQuery } from "@tanstack/react-query"

export const useUserProfile = (id: string) => {
  const { publicProfileApi } = useServicesContext()
  const { data, isLoading } = useQuery({
    queryKey: ["userProfile", id],
    queryFn: async () => {
      return await publicProfileApi.getProfile(id)
    },
    enabled: id !== "",
  })

  return {
    data: data ? PublicProfileEntity.fromDto(data) : null,
    isLoading,
  }
}

export const useCompletedSessions = (id: string, periodicity: Periodicity, limit: number) => {
  const { publicProfileApi } = useServicesContext()

  const { data, isLoading } = useQuery({
    queryKey: ["completedSessions", id, periodicity, limit],
    queryFn: async () => await publicProfileApi.getCompletedSessions(id, periodicity, limit),
  })
  return { data, isLoading }
}
